export default {"src":"/_next/static/media/banner.52bbf04d.svg","height":798,"width":1003,"blurWidth":0,"blurHeight":0};